import { Component, ElementRef, OnInit } from '@angular/core';
import { LayoutService, NavigationService, ActiveRentalService, SecurityCheckModel, SecurityCheckPoint } from 'app-components';
import { AppIntegrationService, AppSettingsService } from 't4-app-integration';
import { PageBase, SafetyCheckQuestionInfo } from 't4core';
import { RentalInfo } from '../../../../../projects/t4core/src/public-api';
import { SwapConfirmationDialog } from '../../../Booking/dialogs/swap-confirmation/swap-confirmation';



@Component({
    selector: 'app-security-check',
    templateUrl: './security-check.component.html',
    standalone: false
})
export class SecurityCheckComponent extends PageBase implements OnInit {

  public securityCheck = new SecurityCheckModel();
  public event: string = "";

  public rentalObjectTitle: string;

  public booking: RentalInfo;
  constructor(el: ElementRef, private aviationService: NavigationService, private RentalService: ActiveRentalService, public layout: LayoutService, private appService: AppIntegrationService, public appSettings: AppSettingsService) { super(el); }

  async ngOnInit() {
    
    this.event = this.aviationService.getParam("event");
     
    var appStore = this.appSettings.clientVersion + " (" + (this.appSettings.appVersion ? this.appSettings.appVersion : "") + ")";
    var info = "Security check started. Event: " + this.event + " Device info: " + appStore + ". " + navigator.userAgent;
    this.booking = await this.RentalService.getBooking();

    //Saves the booking 
    if (this.booking.RentalObject != null) {
      if (this.booking.IsOneWay) {
        this.rentalObjectTitle = this.booking.RentalObject.Alias ?? this.booking.RentalObject.Title
      }
      else {
        this.rentalObjectTitle = this.booking.RentalObject.Title;
      }
       
      //Safety Check Question Info
      var res = await this.RentalService.getSafetyCheckQuestions();
      this.securityCheck = new SecurityCheckModel(res);


        if (!res)
            this.Insights.logError(new Error("No safety checks found"));

    }

    this.Api.post<boolean>("Rental/LogEvent", info, { rentalId: this.booking.Id });
  }
   
  public setCheck(p: SecurityCheckPoint, bValue: boolean) {
    p.Ok = bValue;
    p.Failed = !bValue;
    this.Insights.trackTrace("Question " + p.Key + ": " + bValue)
  }

     
  async swapTrailer() {

    console.log(this.booking);

      const dialogRef = this.Dialog.open(SwapConfirmationDialog, {
        width: '350px',
        position: { top: '50px' },
        data: { comment: this.securityCheck.Remarks }
      });

      var result = await dialogRef.afterClosed().toPromise();
      if (result == true) {
        this.aviationService.executeCommand("SwapTrailer", { rentalId: this.booking.Id, fromPath: "SecurityCheck" })
      }
    
  }

  public async confirm() {
    // Save security check
    var token = this.UI.beginLoading("Intellitrailer.Rental.SecurityCheck.msgSavingSecurityCheck", "Saving security check", null);
    var saveCheck = await this.RentalService.saveSecurityCheck(this.securityCheck, this.event);
    this.UI.loaderCompleted(token);

    this.RentalService.secretSafetyCheckFlag = true;

    // Execute command based on result
    if (saveCheck) {
      if (this.securityCheck.HasDeviation) {
        let booking = await this.RentalService.getBooking();
        this.Api.post<boolean>("/Rental/LogEvent", "Security check completed: Deviations", { rentalId: booking.Id });
        this.aviationService.executeCommand("ConfirmWithDeviations");
      }
      else {
        let booking = await this.RentalService.getBooking();
        this.Api.post<boolean>("/Rental/LogEvent", "Security check completed: All good!", { rentalId: booking.Id });
        this.aviationService.executeCommand("Confirm");
      }
    }
  }
}

